import React, { useState, useEffect } from 'react';
import Link from '@mui/material/Link';
import TritonLogo from '../../assets/triton_logo_150_transparent.png';
import axios from 'axios';
import jwt_decode from "jwt-decode";
import { Alert, AlertTitle, Paper, Box, Typography } from '@mui/material';
import AuthButton from '../authButton';
import ErrorPage from '../ErrorPage/ErrorPage';
import logger from '../../utils/logger';
import pca from '../../azureAuth';

const BASE_URL = process.env.REACT_APP_BASE_URL; // Replace with your API's base URL
export default function SignIn() {
  const [showAlert, setShowAlert] = useState(false);
  const [showAlertmessage, setShowAlertmessage] = useState(false);
  const [token, setToken] = useState(''); // State to store the token
  const [serverError, setServerError] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const handleRedirect = async () => {
      try {
        const response = await pca.handleRedirectPromise();

        if (!isMounted) return;

        if (response) {
          if (response.account) {
            pca.setActiveAccount(response.account);
          }
          setToken(response);
        }
      } catch (error) {
        logger.error('Redirect handling failed:', error);
        if (isMounted) {
          setShowAlertmessage('Sign-in failed. Please try again.');
          setShowAlert(true);
        }
      }
    };

    handleRedirect();

    return () => {
      isMounted = false;
    };
  }, []);
  
  useEffect(() => {
    const loginafterAuth = async () => {
      const headers = {
        'Authorization': `Bearer ${token.idToken}`,
        'Content-Type': 'application/json', // Adjust the content type if needed
      };

      logger.debug("Token", {
        token: token.accessToken
      });
      
      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      logger.debug('User timezone:', userTimezone);
      
      try {
        const response = await axios.post(`${BASE_URL}/auth/login`, 
          { timezone: userTimezone },
          { 
            headers,
            timeout: 10000 // 10 second timeout
          }
        );
        logger.info('Authorized RESPONSE: ', response)
        const { token } = response.data;
        const decodedToken = jwt_decode(token);
        const expirationTimestamp = decodedToken.exp;
        logger.debug('expirationTimestamp :', expirationTimestamp);
        localStorage.setItem('jwtToken', token);
        localStorage.setItem('jwtExpiration', expirationTimestamp);
        // Set flag to show welcome banner on fresh login
        sessionStorage.setItem('justLoggedIn', 'true');
        window.location.reload();

      }
      catch (error) {
        if (error.code === 'ECONNABORTED' || !error.response) {
          logger.error('Backend connection failed:', error);
          setServerError(true);
          return;
        }
        
        const errorMessage = error.response?.data?.message || 'Login failed. Please try again.';
        setShowAlertmessage(errorMessage);
        setShowAlert(true);
        logger.error('Login error:', error);
      }
    };
    if (token) {
      logger.debug("TOKEN ", token)
      loginafterAuth()
    }
    else
      logger.debug("No token generated")

  }, [token])


  // If there's a server connection error, show the error page
  if (serverError) {
    return (
      <ErrorPage 
        title="Connection Error" 
        message="We're having trouble connecting to our servers. The backend system might be temporarily unavailable."
        retryAction={() => window.location.reload()}
      />
    );
  }
  
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', backgroundColor: '#f3f4f6' }}>
      <Paper 
        elevation={3} 
        style={{ 
          padding: '40px', 
          borderRadius: '14px', 
          maxWidth: '480px', 
          width: '100%',
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1)',
          border: '1px solid #d1d5db'
        }}
      >
        <Box display="flex" flexDirection="column" alignItems="center" textAlign="center">
          <img src={TritonLogo} width={180} alt='Triton' style={{ marginBottom: '20px' }} />
          
          <Typography variant="h2" component="h1" style={{ 
            fontSize: '3.5rem', 
            fontWeight: '600', 
            margin: '0 0 30px 0',
            color: '#333'
          }}>
            GSD
          </Typography>
          
          <Typography variant="body1" style={{ marginBottom: '30px', color: '#666' }}>
            Sign in with meltwater SSO to access the GSD platform.
          </Typography>
          
          <Box mb={4}>
            <AuthButton setToken={setToken} />
          </Box>



          <Link 
            href="https://meltwater.slack.com/archives/C066HEYFYH5" 
            variant="body2" 
            target="_blank"
            style={{ marginTop: '20px', color: '#00a29a' }}
          >
            Need access? Contact Team Triton
          </Link>

          {showAlert && (
            <Alert severity="error" style={{ marginTop: '24px', width: '100%' }}>
              <AlertTitle>Error</AlertTitle>
              {showAlertmessage}
            </Alert>
          )}
        </Box>
      </Paper>
    </div>
  );
}
